@if (isLoading) {
  <div class="p-1 d-flex justify-content-center align-items-center">
    <mat-spinner></mat-spinner>
  </div>
}
@if (form) {
  <form [formGroup]="form" (ngSubmit)="uploadFiles(form, null, null)" class="form">
    <div class="row pb-4">
      <!-- File select -->
      <div class="col-12 col-lg-2 pt-2">
        <div class="form-group">
          <div class="input-group">
              <div class="custom-file">
                <input
                  multiple
                  type="file"
                  class="custom-file-input"
                  [lang]="currentLanguage"
                  id="uploadFile"
                  formControlName="files"
                  (change)="fileSelected($event)"
                />
                <label class="custom-file-label" style="width: auto" for="uploadFile" id="uploadLabel">
                  {{ 'DOCUMENTS.choose_file' | translate }}
                </label>
            </div>
          </div>
          @for (file of selectedUploadFiles; track file.index) {
            <div class="d-flex justify-content-between align-items-center">
              <p class="m-0 uploaded-file-name">{{ file.name }}</p>
              <button type="button" mat-icon-button color="warn" (click)="removeSelectedFile(file.index)">
                <mat-icon class="text-danger mat-icon">remove_circle</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
      <!-- Client/Partner selection-->
      @if (clientRoleOptions?.length) {
        <div class="col-12 col-lg-2 col-xl-1 mt-4 mt-lg-0 d-flex">
          <app-input type="select"
                     formControlName="client_role" appearance="outline" [searchable]="true"
                     [label]="'Client'" [selectOptions]="clientRoleOptions"
                     [selectLabel]="'label'" [selectValue]="'value'" class="full-width"
                     [showClear]="false" [fullWidth]="true">
          </app-input>
        </div>
      }
      <!-- Document Type Selector -->
      @if (caseDocumentTypeCategories?.length) {
        <div class="col-12 col-lg-3 col-xl-2">
          <app-input type="select"
                     formControlName="app_document_type_id" appearance="outline" [searchable]="true"
                     [label]="'DOCUMENTS.select_category' | translate" [selectOptions]="caseDocumentTypeCategories"
                     [optGroupProperty]="'document_types'" [optGroupLabel]="'name_' + currentLanguage"
                     [selectLabel]="'name_' + currentLanguage" [selectValue]="'id'" class="full-width"
                     [showClear]="false" [fullWidth]="true">
          </app-input>
        </div>
      }
      <!-- Documentable ID -->
      @if (selectedDocumentType?.custom_input_logic === 'case_creditor_selection' && caseCreditorOptions?.length) {
        <div class="col-12 col-lg-3 col-xl-2">
        <app-input type="select"
                   formControlName="documentable_id" appearance="outline" [searchable]="true"
                   [label]="'Case creditor'" [selectOptions]="caseCreditorOptions"
                   selectLabel="label" selectValue="value" class="full-width"
                   [showClear]="false" [fullWidth]="true">
        </app-input>
      </div>
      } @else if (selectedDocumentType?.custom_input_logic === 'case_public_debt_selection' && casePublicDebtOptions?.length) {
        <div class="col-12 col-lg-3 col-xl-2">
          <app-input type="select"
                     formControlName="documentable_id" appearance="outline" [searchable]="true"
                     [label]="'Public debt'" [selectOptions]="casePublicDebtOptions"
                     selectLabel="label" selectValue="value" class="full-width"
                     [showClear]="false" [fullWidth]="true">
          </app-input>
        </div>
      } @else if (selectedDocumentType?.custom_input_logic === 'case_asset_selection' && caseAssetOptions?.length) {
        <div class="col-12 col-lg-3 col-xl-2">
          <app-input type="select"
                     formControlName="documentable_id" appearance="outline" [searchable]="true"
                     [label]="'Bank account'" [selectOptions]="caseAssetOptions"
                     selectLabel="label" selectValue="value" class="full-width"
                     [showClear]="false" [fullWidth]="true">
          </app-input>
        </div>
      }
      @else if (selectedDocumentType?.custom_input_logic === 'custom_selection' && customDocuments?.length) {
        <!-- Custom Document ID -->
        <div class="col-12 col-lg-3 col-xl-2">
          <app-input type="select"
                     formControlName="app_document_id" appearance="outline" [searchable]="true"
                     [label]="'Custom document'" [selectOptions]="customDocuments"
                     selectLabel="name" selectValue="id" class="full-width"
                     [showClear]="false" [fullWidth]="true">
          </app-input>
        </div>
      }
      <div class="col-auto pt-1 ml-auto ml-lg-0">
        <app-spinner-btn [loading]="isUploading" [name]="'SHARED.submit' | translate"></app-spinner-btn>
      </div>
    </div>
  </form>
}
